import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "DataUpload" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
